import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { z } from "zod"
import { FeedCreateCardPage } from "@/pages/feed"

const searchDefaults = { from: "feed" } as const

const searchSchema = z.object({
	from: z
		.enum(["feed", "profile"])
		.default(searchDefaults.from)
		.catch(searchDefaults.from),
})

export const Route = createFileRoute("/_authenticated/feed/new")({
	validateSearch: searchSchema,
	search: { middlewares: [stripSearchParams(searchDefaults)] },
	component: FeedCreatePageWrapper,
})

function FeedCreatePageWrapper() {
	const { from } = Route.useSearch()
	return <FeedCreateCardPage from={from} />
}
